import { useFormikContext } from 'formik';
import React, {FC} from 'react'
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import { WizardSummaryLayout } from '../../wizard/wizard-summary-layout';
import CredentialDateInfo from '../credential-date-info';
interface Props {
    taskDescription: string;
    cardCode: string;
    deviceType: string;
    device: String | undefined;
    onBack: (event: any) => void;
}

const SummaryForm: FC<Props> = ({ taskDescription, cardCode, deviceType, device, onBack }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <WizardSummaryLayout onBack={(event) => onBack(event)} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div className="flex flex-row">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.taskDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.task)}: <span className="text-sm text-black">{taskDescription}</span></h4>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.procedure)}: <span className="text-sm text-black">{deviceType}</span></h4>
            </div>
        </div> <div className="flex flex-row pt-3">
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.enrolmentDetails)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.card)}: <span className="text-sm text-black">{cardCode}</span></h4>
                <CredentialDateInfo values={values} />
            </div>
        </div> 
        
        <div className="flex flex-row pt-3">
        {device !== undefined ?
            <div className="flex flex-col flex-1">
                <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.selectedDevice)}:</h2>
                <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.device)}: <span className="text-sm text-black">{device}</span></h4>
            </div>
         : null}   
        </div>     
    </WizardSummaryLayout>
}

export default SummaryForm;
